<template>
	<v-card>
		<v-card-text>
			<v-row>
				<v-col cols="auto">
					<translate>Insurance</translate>:
					{{ productName }}
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="auto">
					<translate>Device</translate>:
					{{ deviceName }}
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="auto">
					<translate>Policy number</translate>:
					{{ policyNumber }}
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="auto">
					<translate>Invoice number</translate>:
					{{ invoiceNumber }}
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="auto">
					<translate>Amount</translate>:
					{{ amount }}
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>

export default {
	name: 'InvoiceInformation',
	props: {
		productName: {
			required: true,
			type: String,
		},
		deviceName: {
			required: true,
			type: String,
		},
		policyNumber: {
			required: true,
			type: String,
		},
		invoiceNumber: {
			required: true,
			type: String,
		},
		amount: {
			required: true,
			type: String,
		},
	},
};
</script>

<style scoped>

</style>
